(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldCaptcha', fbFieldCaptchaDirective);

    function fbFieldCaptchaDirective() {
        return {
            restrict: "EA",
            scope: {
                element: "=",
                model: '=',
            },
            template: '<div vc-recaptcha key="vm.key" size="vm.size" badge="vm.badge" ng-model="vm.model" on-success="vm.onSuccess()" ></div>',
            controller: fbFieldCaptchaDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, elem) {
                elem.find('> div').css('margin-bottom', '1.5rem');
            }
        };
    }

    function fbFieldCaptchaDirectiveCtrl(lodash, $rootScope, $timeout) {
        var vm = this;
        this.$onInit = function() {
            if (typeof vm.element.attr.key == typeof undefined) {
                vm.key = '6Le2sg4TAAAAAGT8NZ6mp6yvFpHElFzTcIICESGC';
            } else {
                vm.key = vm.element.attr.key;
            }
            vm.size = vm.element.attr.size;
            vm.badge = vm.element.attr.badge;

            var eventOnSubmit = lodash.get(vm.element, 'attr.event', null);

            if (!!eventOnSubmit) {
                vm.onSuccess = function() {
                    $timeout(function() {
                        $rootScope.$broadcast(eventOnSubmit);
                    });
                }
            } else {
                vm.onSuccess = null;
            }

        }
    }
})();